// NX segmented control and toggle chips (shadcn ToggleGroup restyled): seg on a muted track, chips as pill toggles (tchip).
import { ToggleGroup as ToggleGroupPrimitive } from "radix-ui";
import * as React from "react";

import { cn } from "@/lib/cn";

type ToggleGroupVariant = "seg" | "chips";

const ToggleGroupContext = React.createContext<ToggleGroupVariant>("seg");

function ToggleGroup({
  className,
  variant = "seg",
  children,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Root> & { variant?: ToggleGroupVariant }) {
  return (
    <ToggleGroupPrimitive.Root
      data-slot="toggle-group"
      data-variant={variant}
      className={cn(
        variant === "seg"
          ? "inline-flex w-fit items-center gap-0.5 rounded-[9px] bg-muted p-[3px]"
          : "flex flex-wrap items-center gap-1.5",
        className,
      )}
      {...props}
    >
      <ToggleGroupContext.Provider value={variant}>{children}</ToggleGroupContext.Provider>
    </ToggleGroupPrimitive.Root>
  );
}

function ToggleGroupItem({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Item>) {
  const variant = React.useContext(ToggleGroupContext);
  return (
    <ToggleGroupPrimitive.Item
      data-slot="toggle-group-item"
      className={cn(
        "inline-flex items-center justify-center gap-1.5 whitespace-nowrap outline-none disabled:cursor-not-allowed disabled:opacity-40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-3.5",
        variant === "seg"
          ? "h-7 rounded-[7px] px-[11px] text-chip font-medium text-ink-2 transition-[background-color,color,box-shadow] duration-150 hover:text-foreground data-[state=on]:bg-card data-[state=on]:font-semibold data-[state=on]:text-brand-blue data-[state=on]:shadow-seg"
          : "h-[30px] rounded-pill border border-border bg-card px-[11px] text-chip text-foreground transition-[background-color,border-color,color] duration-150 hover:border-b3 data-[state=on]:border-b3 data-[state=on]:bg-selected data-[state=on]:font-semibold data-[state=on]:text-selected-foreground",
        className,
      )}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Item>
  );
}

export { ToggleGroup, ToggleGroupItem };
